import { render } from "./InquiryDetailsReply.vue?vue&type=template&id=4d9824d0&scoped=true"
import script from "./InquiryDetailsReply.vue?vue&type=script&lang=js"
export * from "./InquiryDetailsReply.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./InquiryDetailsReply.vue?vue&type=style&index=1&id=4d9824d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9824d0"]])

export default __exports__